import GAdTagList from 'components/GAdTag/GAdTagList/GAdTagList';
import withGAdTagListProps from 'viewModel/gAdTag/gAdTagList/withGAdTagListProps';

const ConnectedGAdTagList = withGAdTagListProps(GAdTagList);

export default ConnectedGAdTagList;
